(function () {
  'use strict';

  function initPillBuilder(section) {
    var sid = section.dataset.sectionId;
    var dataEl = document.getElementById('ipb-data-' + sid);
    if (!dataEl) return;

    var ingredients = JSON.parse(dataEl.textContent);
    var fillEl = document.getElementById('ipb-fill-' + sid);
    var panelEl = document.getElementById('ipb-panel-' + sid);
    var completeEl = document.getElementById('ipb-complete-' + sid);
    var panelPlaceholder = panelEl.querySelector('.ipb__panel-placeholder');
    var panelContent = panelEl.querySelector('.ipb__panel-content');
    var panelImg = panelEl.querySelector('.ipb__panel-img');
    var panelLatin = panelEl.querySelector('.ipb__panel-latin');
    var panelName = panelEl.querySelector('.ipb__panel-name');
    var panelOrigin = panelEl.querySelector('.ipb__panel-origin');
    var panelBenefit = panelEl.querySelector('.ipb__panel-benefit');
    var panelTags = panelEl.querySelector('.ipb__panel-tags');
    var dots = section.querySelectorAll('.ipb__dot');
    var capsule = section.querySelector('.ipb__capsule');
    var mobileFillEl = document.getElementById('ipb-mobile-fill-' + sid);
    var mobileCap = document.getElementById('ipb-mobile-cap-' + sid);

    var selected = new Set();
    var panelAnimating = false;
    var currentPanelIndex = -1;

    function getNodes() {
      return section.querySelectorAll('.ipb__node');
    }

    function setFill(count) {
      var pct = (count * 20) + '%';
      fillEl.style.height = pct;
      if (mobileFillEl) mobileFillEl.style.width = pct;
    }

    function updateDots() {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('ipb__dot--filled', selected.has(i));
      });
    }

    function showPanel(index) {
      var ingredient = ingredients[index];
      if (!ingredient) return;

      if (panelAnimating) return;

      if (currentPanelIndex === index) return;

      if (currentPanelIndex === -1) {
        panelPlaceholder.classList.add('ipb__panel-placeholder--hidden');
        panelContent.removeAttribute('hidden');
        populatePanel(ingredient);
        requestAnimationFrame(function () {
          panelContent.classList.add('ipb__panel-content--visible');
        });
        currentPanelIndex = index;
        return;
      }

      panelAnimating = true;
      panelContent.classList.remove('ipb__panel-content--visible');

      setTimeout(function () {
        populatePanel(ingredient);
        requestAnimationFrame(function () {
          panelContent.classList.add('ipb__panel-content--visible');
          panelAnimating = false;
          currentPanelIndex = index;
        });
      }, 150);
    }

    function populatePanel(ingredient) {
      if (ingredient.image_url) {
        panelImg.src = ingredient.image_url;
        panelImg.alt = ingredient.name || '';
        panelImg.style.display = '';
      } else {
        panelImg.style.display = 'none';
      }

      panelLatin.textContent = ingredient.latin_name || '';
      panelName.textContent = ingredient.name || '';
      panelOrigin.textContent = ingredient.origin || '';
      panelBenefit.textContent = ingredient.benefit_text || '';

      panelTags.innerHTML = '';
      [ingredient.tag_1, ingredient.tag_2, ingredient.tag_3].forEach(function (tag) {
        if (!tag) return;
        var span = document.createElement('span');
        span.className = 'ipb__tag';
        span.textContent = tag;
        panelTags.appendChild(span);
      });
    }

    function handleNodeClick(node) {
      var index = parseInt(node.dataset.index, 10);
      if (selected.has(index)) return;

      selected.add(index);
      var allNodes = section.querySelectorAll('.ipb__node[data-index="' + index + '"]');
      allNodes.forEach(function (n) {
        n.classList.add('ipb__node--selected');
        n.setAttribute('aria-pressed', 'true');
      });

      setFill(selected.size);
      updateDots();
      showPanel(index);

      if (selected.size === ingredients.length && ingredients.length === 5) {
        capsule.classList.add('ipb__capsule--complete');
        if (mobileCap) mobileCap.classList.add('ipb__mobile-cap--complete');
        completeEl.removeAttribute('hidden');
        requestAnimationFrame(function () {
          completeEl.classList.add('ipb__complete--visible');
        });
      }
    }

    getNodes().forEach(function (node) {
      node.addEventListener('click', function () {
        handleNodeClick(node);
      });

      node.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleNodeClick(node);
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('.ipb').forEach(function (section) {
      initPillBuilder(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify section re-init on theme editor events
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.ipb');
    if (section) initPillBuilder(section);
  });

})();
